import PropTypes from "prop-types";
import MDBox from "theme/components/MDBox";
import MDInput from "theme/components/MDInput";
import { useState, useEffect } from "react";
import { Snackbar, Alert } from "@mui/material";

function NumberField({ displayName, fieldRef, isOptional, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errMsg, setErrMsg] = useState("Invalid entry provided.");

  const [number, setNumber] = useState(null);
  const [formattedNumber, setFormattedNumber] = useState(null);

  const handleInputChange = (e) => {
    const inputVal = e.target.value;
    const numberVal = inputVal.replace(/,/g, ""); // Remove existing commas
    if (numberVal.length === 0) {
      setFormattedNumber("");
      return;
    }
    const isnum = /^\d+$/.test(numberVal);
    if (!isnum) {
      return;
    }
    const fNum = Number(numberVal).toLocaleString("en"); // Format with commas
    setFormattedNumber(fNum);
  };

  useEffect(() => {
    if (number === null) {
      return;
    }

    const watchField = document.getElementById(`dff_${fieldRef}`);
    watchField.dispatchEvent(new Event("change"));
  }, [number]);

  return (
    <MDBox>
      <MDInput
        margin="dense"
        label={displayName}
        value={formattedNumber}
        type="text"
        fullWidth
        variant="outlined"
        onChange={handleInputChange}
        onBlur={(e) => {
          // const entryValue = e.target.value;
          const inputVal = e.target.value;
          const entryValue = inputVal.replace(/,/g, "");

          const isnum = /^\d+$/.test(entryValue);
          if (!isnum) {
            e.target.value = null;
            setNumber(null);
            setErrMsg(`${displayName} requires only digits`);
            showFieldError(true);
            return;
          }

          const numValue = parseInt(entryValue, 10);
          if (typeof options.min_number !== "undefined") {
            if (numValue < options.min_number) {
              e.target.value = null;
              setNumber(null);
              setErrMsg(`${displayName} cannot be less than ${options.min_number}`);
              showFieldError(true);
              return;
            }
          }

          if (typeof options.max_number !== "undefined") {
            if (numValue > options.max_number) {
              e.target.value = null;
              setNumber(null);
              setErrMsg(`${displayName} cannot be more than ${options.max_number}`);
              showFieldError(true);
              return;
            }
          }

          setNumber(numValue);
        }}
        options={options}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errMsg}
        </Alert>
      </Snackbar>
      <input type="hidden" id={`dff_${fieldRef}`} name={fieldRef} value={number} />
    </MDBox>
  );
}

// Typechecking props of the Transaction
NumberField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

NumberField.defaultProps = {
  options: null,
};

export default NumberField;
